import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ChangeOrderStatusClient, ChangeOrderStatusDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ChangeOrderStatusService {
    constructor(private readonly client: ChangeOrderStatusClient) {}

    async getAll(): Promise<ChangeOrderStatusDto[]> {
        return await lastValueFrom(this.client.changeOrderStatusGetAll());
    }

    async getById(id: number): Promise<ChangeOrderStatusDto> {
        return await lastValueFrom(this.client.changeOrderStatusGetById(id));
    }

    async getByIds(ids: number[]): Promise<ChangeOrderStatusDto[]> {
        return await lastValueFrom(this.client.changeOrderStatusGetByIds(ids));
    }
}
